/*
 * The person a delegate is working for in this tab, sent with every request so the API answers as
 * them. Kept for the tab, so a refresh stays with them and another tab can be someone else.
 */
const Key = "plack.actingAs";

export type ActingAs = { id: string; displayName: string };

export function actingAs(): ActingAs | null {
  try {
    const saved = sessionStorage.getItem(Key);
    return saved ? (JSON.parse(saved) as ActingAs) : null;
  } catch {
    return null;
  }
}

/** Switches to working for someone (or back to oneself), starting again from My Reports. */
export function workFor(person: ActingAs | null): void {
  try {
    if (person) sessionStorage.setItem(Key, JSON.stringify(person));
    else sessionStorage.removeItem(Key);
  } catch {
    // Without storage the switch can't hold; the page stays as it is.
    return;
  }
  window.location.assign("/");
}
